"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SkypeNotificationType;
(function (SkypeNotificationType) {
    SkypeNotificationType[SkypeNotificationType["None"] = 0] = "None";
    SkypeNotificationType[SkypeNotificationType["ToastAndSound"] = 1] = "ToastAndSound";
    SkypeNotificationType[SkypeNotificationType["ToastOnly"] = 2] = "ToastOnly";
})(SkypeNotificationType = exports.SkypeNotificationType || (exports.SkypeNotificationType = {}));
exports.default = SkypeNotificationType;
//# sourceMappingURL=SkypeNotificationType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/data/store/schema/SkypeNotificationType.js
// module id = 3060
// module chunks = 2 39